import { render, staticRenderFns } from "./homework.vue?vue&type=template&id=460e01b3&scoped=true&"
import script from "./homework.vue?vue&type=script&lang=js&"
export * from "./homework.vue?vue&type=script&lang=js&"
import style0 from "./homework.vue?vue&type=style&index=0&id=460e01b3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460e01b3",
  null
  
)

export default component.exports